/**
 * Signed legend prints are labeled `(Signed)`.
 * `(Signature)` is the old suffix. Signature stays the playable spell/gear supertype.
 */
const LEGACY_SIGNED_SUFFIX_RE = /\s*[（(]\s*signature\s*[）)]\s*$/i;

/** Rewrite a trailing `(Signature)` print suffix to `(Signed)`. Other names pass through. */
export function signedPrintDisplayName(name) {
  if (typeof name !== 'string' || !LEGACY_SIGNED_SUFFIX_RE.test(name)) return name;
  return name.replace(LEGACY_SIGNED_SUFFIX_RE, ' (Signed)');
}
